import { LEWOO_TOKEN_KEY } from "../api/lewooConfig";
import { post, get, put, clearAuth } from "./lewooApi";

function persistToken(token) {
  try {
    localStorage.setItem(LEWOO_TOKEN_KEY, token);
  } catch {}
}

function persistUser(user) {
  try {
    localStorage.setItem("lewoo_user", JSON.stringify(user));
  } catch {}
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem("lewoo_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function login(login, password) {
  const res = await post("/api/auth/login", { login, password });
  const { token, user, permissions } = res;

  persistToken(token);
  persistUser(user);
  try {
    if (permissions) localStorage.setItem("lewoo_permissions", JSON.stringify(permissions));
    else localStorage.removeItem("lewoo_permissions");
  } catch {}

  return {
    token,
    user: mapUser(user),
    permissions: permissions || null,
  };
}

export async function me() {
  const res = await get("/api/auth/me");
  const user = res?.user || null;

  if (user) {
    const mapped = mapUser(user);
    persistUser(mapped);
    const permissions = res?.permissions || null;
    try {
      if (permissions) localStorage.setItem("lewoo_permissions", JSON.stringify(permissions));
      else localStorage.removeItem("lewoo_permissions");
    } catch {}
    return { user: mapped, permissions };
  }

  return null;
}

export function getStoredPermissions() {
  try {
    const raw = localStorage.getItem("lewoo_permissions");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function changePassword(currentPassword, newPassword) {
  const res = await put("/api/auth/password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  if (res && typeof res === "object") {
    if ("must_change_password" in res) {
      const stored = getStoredUser();
      if (stored) {
        stored.must_change_password = res.must_change_password;
        persistUser(stored);
      }
    }
  }
  return res;
}

export function logout() {
  clearAuth();
}

function mapUser(u) {
  return {
    id: u.lewoo_uid,
    uid: u.lewoo_uid,
    lewoo_uid: u.lewoo_uid,
    login: u.login,
    email: u.email,
    role: u.role || (u.is_admin ? "admin" : "employee"),
    is_special: !!(u.is_special || u.is_admin),
    department: u.department || u.department_name,
    department_id: u.department_id,
    employee_id: u.employee_id,
    tenant_id: u.tenant_id,
    must_change_password: !!u.must_change_password,
    displayName: u.login || u.email,
  };
}
